import { digObject } from '@domain-group/javascript-utils'

import { Image } from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'

import { ImageModel } from '@models/types'

interface UserImageProps {
  image: ImageModel,
}

const UserImage = (props: UserImageProps) => {
  const {
    image,
  } = props

  const {
    callbacks: {
      createOrEditImage,
    },
  } = useImage(image)

  const imageUrl = digObject(image, 'square_url', '')

  return (
    <Image
      borderRadius={5}
      forwardProps={{
        onClick: () => createOrEditImage(),
        style: { cursor: 'pointer' },
      }}
      url={imageUrl}
    />
  )
}

export default UserImage
